import { Get, Remove, Set } from "../../../../../Request";

export const Formsumbit = async data => {
  await Set({
    url: "/ticket/create",
    data: data,
  });
};
export const GetData = async (pageNumber, limit = 15) => {
  return await Get({
    url: "/ticket/show_list_user",
    data: {
      limit: limit,
    },
    page: pageNumber,
  }).then(data => {
    return data;
  });
};
export const GetTicket = async ticket_id => {
  return await Get({
    url: "/ticket/get_chat_singleticket",
    data: {
      ticket_id,
    },
  }).then(data => {
    return data;
  });
};

export const FormChatSubmit = async data => {
  return await Get({
    url: "/ticket/new_question",
    data: data,
  }).then(result => {
    if (result) {
      return result;
    } else {
      return false;
    }
  });
};
